{
  "bindings": {
    "minimal-cta:tap": {
      "flow": "navigateToSignup"
    }
  },
  "schemaVersion": "4.0",
  "blockType": "hero-minimal"
}
